export const LOGIN_STARTED = 'LOGIN/STARTED';
export const LOGIN_SUCCESS = 'LOGIN/SUCCESS';
export const LOGIN_FAILURE = 'LOGIN/FAILURE';

export const LOGOUT = 'LOGOUT';
